import api from './api'

/**
 * Servicio para obtener banners administrables desde el CMS.
 *
 * Backend endpoint: GET /api/dashadmin/campaigns/banners (baseURL ya incluye /api)
 */
const bannersService = {
  /**
   * @returns {Promise<{ home: { desktop: string, mobile: string }, ventaPack: { desktop: string, mobile: string } }>}
   */
  async getCampaignBanners() {
    const { data } = await api.get('/dashadmin/campaigns/banners')
    return data
  }
}

export default bannersService
